import requests from '@/utils/axios'
// const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }

const baseUrl = '/api-gateway/jpaas-yzqyzygx-web-server'
const jactUrl = '/api-gateway/jpaas-jact-web-server'

const api = {
  getUserInfo: baseUrl + '/front/userCenter/getUserInfo', // 用户信息
  getTypeList: baseUrl + '/front/appealConsultation/getTypeList', // 诉求类型查询
  getHotList: baseUrl + '/front/appealConsultation/getHotList', // 热门诉求咨询列表
  homeSearch: baseUrl + '/front/home/search', // 搜索
  login: baseUrl + '/front/test/login', // 临时登录
  findMyTransacts: jactUrl + '/interface/transact/find-my-transacts', // jact我的办件列表查询
  findTransactDetail: jactUrl + '/interface/transact/find-transact-detail', // jact获取办件详细
  // 法律法治
  mailWrite: jactUrl + '/front/mail-write.do'
}

export const appealConsultationAPI = {
  getUserInfo (param) {
    return requests({
      url: api.getUserInfo,
      method: 'get',
      params: param
    })
  },
  getTypeList () {
    return requests({
      url: api.getTypeList,
      method: 'get'
    })
  },
  getHotList (param) {
    return requests({
      url: api.getHotList,
      method: 'get',
      params: param
    })
  },
  homeSearch (param) {
    return requests({
      url: api.homeSearch,
      method: 'get',
      params: param
    })
  },
  login (param) {
    return requests({
      url: api.login,
      method: 'post',
      data: param
    })
  },
  findMyTransacts (param) {
    return requests({
      url: api.findMyTransacts,
      method: 'get',
      params: param
    })
  },
  findTransactDetail (param) {
    return requests({
      url: api.findTransactDetail,
      method: 'get',
      params: param
    })
  },
  mailWrite (param) {
    return requests({
      url: api.mailWrite,
      method: 'get',
      params: param
    })
  }
}
